export default __webpack_public_path__ + "static/media/group4.25a15978.jpg";